module.exports = __webpack_public_path__ + "static/media/alcohol-in-gel.aaa16d1f.png";